/**
 * @name core
 * @description Core in ngx-responsive
 *
 * @license MIT
 */

export * from './constants/index';
export * from './interfaces/index';
export * from './providers/index';
export * from './types/index';
